import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "a",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.382 12.973"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.403,.4C.94-.133,1.811-.133,2.348,.4L11.691,9.676,21.034,.4c.537-.533,1.408-.533,1.945,0,.537,.533,.537,1.398,0,1.931L12.664,12.573c-.537,.533-1.408,.533-1.945,0L.403,2.331C-.134,1.798-.134,.933,.403,.4Z",
      fill: "#6e0afa",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }